<!--
 * @Author: zhangmh31513
 * @Date: 2021-11-10 16:27:39
 * @LastEditTime: 2021-11-24 17:09:34
 * @LastEditors: zhangcx33595
 * @Description: 直播组件
 * @FilePath: \openplat-web\src\gtn\views\frontViews\developerConference\components\livePlayer.vue
 * 有问题请第一时间来联系我
-->
<template>
  <div>
    <div class="error-tips" v-if="playError">
      <h-button type="info" @click="reFresh">重新加载</h-button>
    </div>
    <video-player
      v-else
      class="video-player-box"
      ref="videoPlayer"
      :options="playerOptions"
      :playsinline="true"
      customEventName="customstatechangedeventname"
      @play="onPlayerPlay($event)"
      @waiting="onPlayerWaiting($event)"
      @playing="onPlayerPlaying($event)"
      @error="onErrors($event)"
    >
    </video-player>
    <!--
      @pause="onPlayerPause($event)"
      @canplay="onPlayerCanplay($event)"
      @canplaythrough="onPlayerCanplaythrough($event)"
      @statechanged="playerStateChanged($event)"
      @ready="playerReadied" -->
  </div>
</template>
<script>
import "video.js/dist/video-js.css";
import "videojs-contrib-hls";
import { checkLogin } from "@/api/developerConference";

import { videoPlayer } from "vue-video-player";
export default {
  name: "LivePlayer",
  components: {
    videoPlayer
  },
  props: {
    videoSrc: {
      type: String,
      default: ""
    },
    mainTitle: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      playerOptions: {
        // 是否关闭音频
        // muted: true,
        // 初始语言，默认为英语，code参见：https://www.iana.org/assignments/language-subtag-registry/language-subtag-registry
        language: "zh-CN",
        // 播放速度，指定后Video.js将显示一个控件(vjs-playback-rate类的控件)，允许用户从选项数组中选择播放速度
        // playbackRates: [0.5, 1.0, 1.5, 2.0],
        // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值，表示长宽比例
        aspectRatio: "16:9",
        // 等同于原生<video>标签中的一组<source>子标签，可实现优雅降级；type 属性规定媒体资源的 MIME 类型，标准类型可参见：https://www.iana.org/assignments/media-types/media-types.xhtml；
        sources: [
          {
            type: "application/x-mpegURL",
            src: ""
          }
        ],
        // 兼容顺序，默认值是['html5']，这意味着html5技术是首选，其他已注册的技术将按其注册的顺序在该技术之后添加。
        // techOrder: ["flash"],
        // 在视频开始播放之前显示的图像的URL（封面），这通常是一个视频帧或自定义标题屏幕，一旦用户点击“播放”，图像就会消失。
        poster: require("../../../../assets/developerConference/hall-bg.png"),
        // // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        fluid: true,
        notSupportedMessage: "此视频暂无法播放，请稍后再试" //允许覆盖Video.js无法播放媒体源时显示的默认信息。
      },
      playError: false
    };
  },
  mounted() {
    try {
      this.player.play();
    } catch (e) {
      console.log(e);
    }
  },
  watch: {
    videoSrc: {
      handler: function(nval, oval) {
        this.playerOptions.sources[0].src = nval;
      },
      immediate: true
    }
  },
  beforeDestroy() {
    try {
      this.player.dispose();
      clearTimeout(this.timer);
    } catch (e) {
      console.log(e);
    }
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player;
    }
  },
  methods: {
    // 各个事件监听
    onPlayerPlay(player) {
      checkLogin().then(res => {
        if (res) {
          try {
            // 对用户播放次数做埋点
            let hsid = this.$store.getters.hsid||'';
            this.gioTrackEvent("LDC_loginUserVideoPlayClick", {
              videoName_var: this.mainTitle.substring(
                0,
                this.mainTitle.length - 2
              ),
              hsUserId_var: hsid,
              deviceType_var: "Web"
            });
          } catch (e) {
            console.log("播放视频埋点出错", e);
          }
          this.$emit("addPhoton");
        } else {
          if (this.player) this.$refs.videoPlayer.player.pause();
        }
      });
    },
    onPlayerWaiting(e) {
      const that = this;
      that.timer = setTimeout(() => {
        that.playError = true;
        that.$hMessage.info(
          "播放可能出现了一些问题，请检查你的网络环境并刷新网站，或者直播已结束"
        );
        that.player.pause();
      }, 20000);
    },
    onPlayerPlaying(e) {
      clearTimeout(this.timer);
      this.timer = null;
    },
    onErrors(e) {
      let s = "";
      switch (e.error_.code) {
        case 1:
          s += "取消了播放.";
          break;
        case 2:
          s += "网络错误引起的加载失败，请重新刷新试试";
          break;
        case 3:
          s += "当前浏览器不支持这个视频格式，更换浏览器打开试试吧";
          break;
        case 4:
          s += "当前浏览器不支持这个视频格式，更换浏览器打开试试吧";
          break;
        default:
          s += "An unknown error occurred.";
          break;
      }
      const tempEle = e.errorDisplay.contentEl();
      tempEle.childNodes[0].nodeValue = s;
      e.errorDisplay.createEl(tempEle);
      this.playError = true;
      that.$hMessage.info(
        "播放可能出现了一些问题，请检查你的网络环境并刷新网站，或者直播已结束"
      );
    },
    // 加载错误点击刷新按钮
    reFresh() {
      window.location.reload();
    }
  }
};
</script>
<style lang="scss" scoped>
.error-tips {
  width: 100%;
  max-width: 863px;
  height: 486px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url("../../../../assets/developerConference/hall-bg.png");
}
</style>
<style lang="scss">
.video-js .vjs-big-play-button {
  left: 50%;
  top: 50%;
  width: 1.5em;
  transform: translate(-50%, -50%);
  border-radius: 50%;
}
.video-js {
  & .vjs-duration {
    display: block !important;
  }

  & .vjs-current-time {
    display: block !important;
  }
}
.video-js.vjs-paused .vjs-big-play-button {
  /* 视频暂停时显示播放按钮 */
  display: block;
}
.video-js.vjs-error .vjs-big-play-button {
  /* 视频加载出错时隐藏播放按钮 */
  display: none;
}
.vjs-loading-spinner {
  /* 加载圆圈 */
  font-size: 2.5em;
  width: 2em;
  height: 2em;
  border-radius: 1em;
  margin-top: -1em;
  margin-left: -1.5em;
}
/* 消去播放错误的x */
.vjs-error .vjs-error-display:before {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/gtn/views/frontViews/developerConference/components/livePlayer.vue